import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsMaxBetButtonControl } from "../ags-max-bet-button-control";

export class AgsMaxBetButtonControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("ags_max_bet") != null;
    }

    public build(layer: Layers): AgsMaxBetButtonControl[] {
        return [new AgsMaxBetButtonControl(layer.getFlexiButton("ags_max_bet"))];
    }
}
